import { UpdateMenuInput } from '@/API';
import { updateMenuWithConnection } from '@/appsync/graphql/menu';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { UpdateTimeStampQueryParam } from '@/types/type';

export const updateAccessedTimeStamp = async (
  param: UpdateTimeStampQueryParam
) => {
  const accessedTimeStamp: number = Date.now();
  const input: UpdateMenuInput = { ...param, accessedTimeStamp };
  await graphqlQuery(updateMenuWithConnection, { input });
};
